module.exports = __webpack_public_path__ + "img/CROPROTATION.6a991d17.svg";